module.exports = __webpack_public_path__ + "static/img/shcygn6.aaaeb3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/shcygn6.png
// module id = 376
// module chunks = 0